const FETCH_DATA_REQUEST = "FETCH_DATA_REQUEST";
const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";
const FETCH_BY_SEARCH = "FETCH_BY_SEARCH";
const FETCH_DATA_FAILURE = "FETCH_DATA_FAILURE";

const CREATE_POST_REQUEST = "CREATE_POST_REQUEST";
const CREATE_POST_SUCCESS = "CREATE_POST_SUCCESS";
const CREATE_POST_FAILURE = "CREATE_POST_FAILURE";

const FETCH_POST = "UPDAFETCH_POSTTE_POST";
const UPDATE_POST = "UPDATE_POST";
const DELETE_POST = "DELETE_POST";
const LIKE_POST = "LIKE_POST";

export {
  FETCH_DATA_REQUEST,
  FETCH_DATA_SUCCESS,
  FETCH_BY_SEARCH,
  FETCH_DATA_FAILURE,
  CREATE_POST_REQUEST,
  CREATE_POST_SUCCESS,
  CREATE_POST_FAILURE,
  FETCH_POST,
  UPDATE_POST,
  DELETE_POST,
  LIKE_POST,
};
